import MintItemsModal from './MintItemsModal.container'
export default MintItemsModal
